import layout from './DynamicAssociationSummaryView.html?raw';
import SummaryView from '@/SummaryViews/SummaryView';
import ComponentManager from '@/Management/ComponentManager';

export default class DynamicAssociationSummaryView extends SummaryView {

    private summaryView: JQuery<HTMLElement>;

    constructor(private viewModel, element) {
        super();
    }

    public getSummaryView() {
        if (this.summaryView != null) {
            return this.summaryView;
        }

        this.summaryView = this.applyViewModel(layout, this.viewModel);

        this.applyBindings(this.summaryView, {
            controlName: 'dynamicassociationsummaryview'
        });

        return this.summaryView;
    }

}

ComponentManager.setSummaryView('DynamicAssociationSummaryView', DynamicAssociationSummaryView, 'RADPresentation.HTMLClient.DefaultViewExtensions');